import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { saveAs } from "file-saver";
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { BASE_URL } from '../app.module';

export class HttpGQ {

  constructor(private http: HttpClient, private cookieService: CookieService) {
  }

  /**
  * Constructs a `POST` request that interprets the body as a
  * JSON object and returns the response body as a JSON object.
  *
  * @param url The endpoint URL.
  * @param body The content to replace with.
  * @param options HTTP options
  *
  * @return An `Observable` of the response, with the response body as a JSON object.
  */
  post(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  }): Observable<Object> {

    if (this.cookieService.check("XSRF-TOKEN")) {
      let token = this.cookieService.get("XSRF-TOKEN");
      let header = new HttpHeaders();
      header = header.set("X-XSRF-TOKEN", token);

      if (options === undefined || options === null)
        options = {};
      options.headers = header;

    }

    return this.http.post(url, body, options);
  }

  /**
  * Constructs a `GET` request that interprets the body as a JSON object and
  * returns the response body as a JSON object.
  *
  * @param url     The endpoint URL.
  * @param options The HTTP options to send with the request.
  *
  *
  * @return An `Observable` of the response body as a JSON object.
  */
  get(url: string, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    observe?: 'body';
    params?: HttpParams | {
      [param: string]: string | string[];
    };
    reportProgress?: boolean;
    responseType?: 'json';
    withCredentials?: boolean;
  }): Observable<Object> {

    if (this.cookieService.check("XSRF-TOKEN")) {
      let token = this.cookieService.get("XSRF-TOKEN");
      let header = new HttpHeaders();
      header = header.set("X-XSRF-TOKEN", token);

      if (options === undefined || options === null)
        options = {};
      options.headers = header;

    }

    return this.http.post(url, undefined, options);
  }

}

@Injectable()
export class RestService {

  public baseUrl: string;
  public get URL(): string { return this.baseUrl }
  public http: HttpGQ;

  constructor(private http1: HttpClient, private cookieService: CookieService, public router: Router, injector: Injector) {

    this.http = new HttpGQ(http1, cookieService);

    const baseUrl = injector.get(BASE_URL);
    const index = baseUrl.lastIndexOf("/");
    if (index === baseUrl.length - 1)
      this.baseUrl = baseUrl.substr(0, baseUrl.length - 1);
    else
      this.baseUrl = baseUrl;
  }

  downLoadFile(data: BlobPart, type: string, namefile: string, caller: any, returnFunction: Function | undefined = undefined) {
    returnFunction = returnFunction === undefined ? this.functionReplace : returnFunction;

    const blob = new Blob([data], { type: type });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    document.body.appendChild(a);

    a.href = url;
    a.download = namefile;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    returnFunction.call(caller);
  }

  protected SuscriveResult(caller: any, returnFunction: Function | undefined = undefined): any {

    returnFunction = returnFunction === undefined ? this.functionReplace : returnFunction;
    return (result: ReturnData) => {
      try {
        const resultJson = result as ReturnData;
        returnFunction?.call(caller, resultJson);
      }
      catch (error) {
        const r: ReturnData = new ReturnData();
        r.data = error;
        r.isError = true;
        returnFunction?.call(caller, r);
      }
    };
  }

  protected SuscriveFault(caller: any, failFunction: Function | undefined = undefined): any {

    failFunction = failFunction === undefined ? this.functionReplace : failFunction;
    return (error: { status: number; }) => {
      if (error.status === 401) {
        this.router.navigate(["/login"]);
        return;
      }
      else if (error.status === 403) {
        const r: ReturnData = new ReturnData();
        r.data = "No tiene permisos para realizar esta acción";
        r.isError = true;
        r.codError = 403;
        failFunction?.call(caller, r);
      }
      else if (error.status === 429) {
        const r: ReturnData = new ReturnData();
        r.data = "No se pudo realizar esta acción, reintente nuevamente";
        r.isError = true;
        r.codError = 429;
        failFunction?.call(caller, r);
      }
      else if (error.status === 405) {
        const r: ReturnData = new ReturnData();
        r.data = "Error inesperado (405)";
        r.isError = true;
        r.codError = 405;
        failFunction?.call(caller, r);
      }
      else if (error.status === 500) {
        const r: ReturnData = new ReturnData();
        r.data = "Error inesperado";
        r.isError = true;
        r.codError = 500;
        failFunction?.call(caller, r);
      }
      else {
        const r: ReturnData = new ReturnData();
        r.data = error;
        r.isError = true;
        console.error(error);
        failFunction?.call(caller, r);
      }
    };
  }

  protected functionReplace(data: any) { }

  protected SuscriveDownloadFileResult(caller: any, fileName = "", returnFunction: Function | undefined = undefined): any {
    returnFunction = returnFunction === undefined ? this.functionReplace : returnFunction;
    return (result: any) => {
      try {
        let blob: Blob;
        if (result.size !== undefined && result.type !== undefined && result.type !== "application/json") {
          blob = result;

        } else if (result.size !== undefined && result.type !== undefined && result.type === "application/json") {
          result.text().then((value: string) => {
            returnFunction?.call(caller, JSON.parse(value));
          });
          return;
        } else if (result.byteLength !== undefined) {
          blob = new Blob([result], { type: "application/octet-stream" });
        }
        else {
          if (result.headers.get("content-disposition") !== null) {
            const headerFile = result.headers.get("content-disposition").toString().split(";");
            for (let i = 0; i < headerFile.length; i++) {
              if (headerFile[i].trim().startsWith("filename=")) {
                fileName = headerFile[i].replace("filename=", "").trim();
                break;
              }
            }
          }
          blob = result.blob();
        }

        if (blob !== null) {
          saveAs(blob, fileName);
          const resultJson = new ReturnData();
          resultJson.isError = false;
          resultJson.isSecurity = false;
          returnFunction?.call(caller, resultJson);
        }
        else {
          const resultJson = result.json() as ReturnData;
          returnFunction?.call(caller, resultJson);
        }
      }
      catch (error) {
        const r: ReturnData = new ReturnData();
        r.data = error;
        r.isError = true;
        returnFunction?.call(caller, r);
      }
    };
  }
}

export class RestCrudService<T> extends RestService {
  public Controller = "";

  public Buscar(caller: any, page: Page, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/api/" + this.Controller + "/Buscar", page).subscribe(this.SuscriveResult(caller, returnFunction), this.SuscriveFault(caller, returnFunction));
  }

  public Guardar(caller: any, model: T, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/api/" + this.Controller + "/Guardar", model).subscribe(this.SuscriveResult(caller, returnFunction), this.SuscriveFault(caller, returnFunction));
  }

  public Borrar(caller: any, model: T, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/api/" + this.Controller + "/Borrar", model).subscribe(this.SuscriveResult(caller, returnFunction), this.SuscriveFault(caller, returnFunction));
  }

  public Exportar(caller: any, page: Page, returnFunction: Function | undefined = undefined) {
    this.http.post(this.baseUrl + "/api/" + this.Controller + "/Exportar", page, { responseType: 'blob' as 'json' }).subscribe(this.SuscriveDownloadFileResult(caller, this.Controller + ".xlsx", returnFunction), this.SuscriveDownloadFileResult(caller, this.Controller + ".xlsx", returnFunction));
  }

}

export class ReturnData {
  public data: any = "";
  public isError = true;
  public ticks = 0;
  public isSecurity = false;
  public codError = 0;
}

export class Page {
  constructor(data: Page) {
    if (data !== null) {
      this.pageIndex = data.pageIndex;
      this.pageCount = data.pageCount;
      this.pageSize = data.pageSize;
      this.recordCount = data.recordCount;
      this.filter = data.filter;
      this.order = data.order;
    }
  }

  public pageIndex = 1;
  public pageCount = 0;
  public pageSize = 25;
  public recordCount = 0;
  public filter: Array<PagingFilter> = new Array<PagingFilter>();
  public order: Array<PagingOrder> = new Array<PagingOrder>();
  public data: any = null;
}

export class PageGeneric<T extends object> extends Page {
  public data: Array<T> = new Array<T>();
}

export class PagingFilter {
  public property = "";
  public condition: ">" | ">=" | "<" | "<=" | "=" | "con" | "=|T" | "X" | "x" = "con";
  public value: string | number | Date | boolean | object = "";
  public valueType = "";
}

export class PagingOrder {
  public property = "";
  public direction: "+" | "-" = "+";
}
